import * as React from "react";
import { CSSTransition } from "react-transition-group";

export function Step({ show, children }: { show: boolean; children: React.ReactNode }) {
  const nodeRef = React.useRef<HTMLDivElement | null>(null);
  return (
    <CSSTransition
      in={show}
      timeout={150}
      classNames="step"
      mountOnEnter={true}
      unmountOnExit={true}
      appear={show}
      nodeRef={nodeRef}
    >
      <div ref={nodeRef} className="step-slot rounded-md">
        {children}
      </div>
    </CSSTransition>
  );
}

